module.exports = __webpack_public_path__ + "img/Avatar-13.50ed06cf.svg";